import React from "react";
import { ShieldCheck, MedalMilitary } from "@phosphor-icons/react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import CTASection from "@/components/CTASection";
import { CERTIFICATIONS } from "@/lib/site";

export default function Certifications() {
  return (
    <>
      <SEO title="Certifications" description="ISO 9001, CIMS-GB, OSHA, EPA Safer Choice, GBAC STAR, Green Seal — Empire Serv's certifications and standards." path="/certifications" />
      <PageHero
        eyebrow="Certifications"
        title="Standards your auditor will recognize."
        subtitle="Independent verification keeps our team accountable — and your contract defensible."
        image="https://images.pexels.com/photos/8273515/pexels-photo-8273515.jpeg"
        testId="certifications-hero"
      />
      <section className="es-section bg-white">
        <div className="es-container">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {CERTIFICATIONS.map((c, i) => (
              <div key={c.name} data-testid={`cert-card-${i}`} className="es-card p-7 relative overflow-hidden">
                <div className="absolute top-0 right-0 w-1 h-full bg-[var(--es-accent)]" />
                <MedalMilitary size={28} weight="fill" className="text-[var(--es-accent)]" />
                <h3 className="mt-4 text-lg font-bold text-[var(--es-navy)]" style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>{c.name}</h3>
                <p className="mt-2 text-sm text-[var(--es-text-muted)] leading-relaxed">{c.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="es-section bg-[var(--es-bg)]">
        <div className="es-container grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="es-eyebrow">Insurance & Bonding</div>
            <h2 className="es-h2 text-[var(--es-navy)] mt-3">Coverage that satisfies any procurement office.</h2>
          </div>
          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
            {[
              { label: "General Liability", value: "$2M / $4M aggregate" },
              { label: "Workers' Compensation", value: "Statutory + Employer's Liability" },
              { label: "Auto Liability", value: "$1M CSL — owned/non-owned/hired" },
              { label: "Janitorial Bond", value: "$25K — additional bond on request" },
              { label: "Umbrella / Excess", value: "$5M follow-form" },
              { label: "Cyber & Crime", value: "$1M — employee dishonesty endorsed" },
            ].map((i) => (
              <div key={i.label} className="bg-white border border-[var(--es-border)] p-5 rounded-sm">
                <div className="flex items-center gap-2">
                  <ShieldCheck size={18} weight="fill" className="text-[var(--es-accent)]" />
                  <div className="text-[10px] uppercase tracking-[0.2em] font-semibold text-[var(--es-text-muted)]">{i.label}</div>
                </div>
                <div className="mt-2 font-bold text-[var(--es-navy)]">{i.value}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </>
  );
}
